const CAMEL_CASE_TO_SPACE_SEPERATED_SPECIAL_CASES: Record<string, string> = {
    "antibioticsAntimycoticsPercentage": "AA (%)",
    "lGlutaminePercentage": "L-Gln (%)"
}

export class StringFormatter {
    public static camelCaseToSpaceSeperatedString(str: string): string {
        if (CAMEL_CASE_TO_SPACE_SEPERATED_SPECIAL_CASES[str] !== undefined) {
            return CAMEL_CASE_TO_SPACE_SEPERATED_SPECIAL_CASES[str]
        }
        let strWithSpace: string = str.replace(/([A-Z][a-z])|(CRISPR|GC)/g, " $1$2")
        let strWithSpaceArr: string[] = strWithSpace.split(" ")
        for (let i: number = 0; i < strWithSpaceArr.length; i++) {
            if (i === 0) {
                strWithSpaceArr[i] = strWithSpaceArr[i].charAt(0).toUpperCase() + strWithSpaceArr[i].slice(1)
            }

            if (strWithSpaceArr[i] === "Percentage") {
                strWithSpaceArr[i] = "(%)"
            }

            if (strWithSpaceArr[i] === "Glutamine") {
                strWithSpaceArr[i] = "Gln"
            }

            if (["Fbs", "Neaa", "Crispr", "Aa", "Rnp"].includes(strWithSpaceArr[i])) {
                strWithSpaceArr[i] = strWithSpaceArr[i].toUpperCase()
            }
        }
        return strWithSpaceArr.join(" ")
    }
}